var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-page',{attrs:{"kicker":_vm.kicker,"title":_vm.t.greeting(_vm.firstName),"lead":_vm.lead,"actions":[_vm.t.actions.primary, _vm.t.actions.secondary],"stats":_vm.stats,"setup":_vm.setup,"tiles-title":_vm.t.tilesTitle,"tiles":_vm.tiles,"footnote":_vm.t.footnote,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }